const FEE_BY_CURRENCY = Object.freeze({
  GBP: { percent: 0.015, fixedMinor: 20 },
  USD: { percent: 0.029, fixedMinor: 30 },
  AUD: { percent: 0.029, fixedMinor: 30 },
  NZD: { percent: 0.029, fixedMinor: 30 },
  CAD: { percent: 0.029, fixedMinor: 30 },
  EUR: { percent: 0.029, fixedMinor: 30 },
});

export function normalizeSailingBoatPayment(input = {}) {
  return {
    required: input?.required === true,
    pricingMode: input?.pricingMode === 'hourly' ? 'hourly' : 'flat',
    amountMinor: Math.max(0, Math.round(Number(input?.amountMinor || 0))),
    collectionTiming: ['at_booking', 'on_assignment', 'after_booking'].includes(input?.collectionTiming) ? input.collectionTiming : 'at_booking',
    tagMode: ['all', 'exempt_tags', 'only_tags'].includes(input?.tagMode) ? input.tagMode : 'all',
    paymentTags: Array.isArray(input?.paymentTags) ? input.paymentTags.filter(Boolean) : [],
    blockFutureBookings: input?.blockFutureBookings === true,
  };
}

export function sailingMemberPays(payment, memberTags = []) {
  const settings = normalizeSailingBoatPayment(payment);
  if (!settings.required || settings.amountMinor <= 0) return false;
  const tags = new Set(Array.isArray(memberTags)
    ? memberTags
    : Object.entries(memberTags || {}).filter(([, enabled]) => Boolean(enabled)).map(([name]) => name));
  const matches = settings.paymentTags.some((tag) => tags.has(tag));
  if (settings.tagMode === 'exempt_tags') return !matches;
  if (settings.tagMode === 'only_tags') return matches;
  return true;
}

export function sailingBoatPriceMinor(payment, minutes, memberTags = []) {
  const settings = normalizeSailingBoatPayment(payment);
  if (!sailingMemberPays(settings, memberTags)) return 0;
  return settings.pricingMode === 'hourly'
    ? Math.max(0, Math.round((settings.amountMinor * Math.max(0, Number(minutes || 0))) / 60))
    : settings.amountMinor;
}

export function grossUpSailingBoatPrice(baseMinor, currency = 'GBP') {
  const base = Math.max(0, Math.round(Number(baseMinor || 0)));
  if (!base) return 0;
  const fee = FEE_BY_CURRENCY[String(currency || 'GBP').toUpperCase()] || { percent: 0.029, fixedMinor: 30 };
  let gross = Math.max(base, Math.ceil((base + fee.fixedMinor) / (1 - fee.percent)));
  while (gross - (Math.round(gross * fee.percent) + fee.fixedMinor) < base) gross += 1;
  return gross;
}

export function formatSailingBoatMoney(minor, currency = 'GBP') {
  try {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: String(currency || 'GBP').toUpperCase() }).format(Number(minor || 0) / (['JPY', 'KRW', 'VND'].includes(String(currency).toUpperCase()) ? 1 : 100));
  } catch (_) {
    return `${currency} ${Number(minor || 0) / 100}`;
  }
}
